import { Injectable } from "@angular/core";
import * as mapboxgl from "mapbox-gl";
import { EstatusJSON } from "../models/EstatusJSON";

@Injectable({
  providedIn: "root",
})
export class MiniMapService {

  emptyGeoJson = {
    type: "FeatureCollection",
    features: [],
  };
  

  private _CENTER_LAT = 24.226252;
  private _CENTER_LNG = -103.0266765;
  private _CENTER_ZOOM = 4.5;


  miniMap: any;

  
  configUrl: string;
  public Result;
  estatus: EstatusJSON;
  constructor() {

  }

  CreateMap(geofenceGeoJson: string, locationGeoJson: string) {
    console.log("CreateMap", geofenceGeoJson, locationGeoJson);
    
    
    // verifica que los geojson no esten vacios
    geofenceGeoJson = (geofenceGeoJson == "" || geofenceGeoJson == null) ? JSON.stringify(this.emptyGeoJson) : geofenceGeoJson;
    locationGeoJson = (locationGeoJson == "" || locationGeoJson == null) ? JSON.stringify(this.emptyGeoJson) : locationGeoJson;
    
    this.miniMap = new mapboxgl.Map({
      container: 'mini-map',
      style: 'mapbox://styles/mapbox/traffic-day-v2',
      center: [this._CENTER_LNG, this._CENTER_LAT], 
      zoom: this._CENTER_ZOOM, 
      interactive: true, 
      attributionControl: false,
    });
  
    this.miniMap.on('load', () => {
      var geometries: any[] = [];
      if (JSON.parse(geofenceGeoJson).features.length > 0 && JSON.parse(geofenceGeoJson).features[0] != null ){
        geometries.push(JSON.parse(geofenceGeoJson).features[0].geometry);
        this.addGeometryLayer(JSON.parse(geofenceGeoJson));
      }
  
      if (JSON.parse(locationGeoJson).features.length > 0 && JSON.parse(locationGeoJson).features[0] != null ){
        geometries.push(JSON.parse(locationGeoJson).features[0].geometry);
        this.addLocationLayer(JSON.parse(locationGeoJson));
      }
      
      if (geometries.length > 0)
        this.FitBounds(geometries);
    });
  }

  deleteMap() {
    this.miniMap.remove();
  }

  addGeometryLayer(geometry : any): void {

    // Agregar la fuente al mapa.
    this.miniMap.addSource('geometry-source', {
      type: 'geojson',
      data: geometry
    });


    this.miniMap.addLayer({
      id: 'geometry-layer',
      source: 'geometry-source',
      type: "fill",
      paint: {
        "fill-color": "#9de02a",
        "fill-opacity": 0.4,
      },
    });
  }

  addLocationLayer(geometry : any): void {

    var categoryIcons = JSON.parse(localStorage.getItem("UrlList"));
    var imageObj = categoryIcons.find(x => x.name == "nodes.png");
    console.log("image", imageObj);
    
    // Agregar la fuente al mapa.
    this.miniMap.addSource('location-source', {
      type: 'geojson',
      data: geometry
    });

    // agregar icono
    this.miniMap.loadImage(imageObj.url, (error, image) => {
      if (error) throw error;
      if (!this.miniMap.hasImage(imageObj.name))
        this.miniMap.addImage(imageObj.name, image, { sdf: false });
    });

    this.miniMap.addLayer({
      id: 'location-layer',
      source: 'location-source',
      type: "symbol",
      filter: ["!", ["has", "point_count"]],
      layout: {
        // This icon is a part of the Mapbox Streets style.
        // To view all images available in a Mapbox style, open
        // the style in Mapbox Studio and click the "Images" tab.
        // To add a new image to the style at runtime see
        // https://docs.mapbox.com/mapbox-gl-js/example/add-image/
        'icon-image': imageObj.name,
        "icon-size": 0.15,
      },
      paint: {
        "icon-color": "#7DFF45",
        "icon-halo-color": "#fff",
        "icon-halo-width": 2,
      },
    });
    
  }



  FitBounds(geometries: any[]) {
    var coordenadasFinal = [];
    for ( const geometry of geometries) {
      var coordsTemp = [];
      
      if (geometry.type == "MultiPolygon"){
        coordsTemp = coordsTemp[0];
        coordenadasFinal.push(coordsTemp);
      }
      if (geometry.type == "LineString"){
        coordsTemp = geometry.coordinates;
        coordenadasFinal.push(coordsTemp);
      }
      if (geometry.type == "Polygon"){
        coordsTemp = geometry.coordinates[0];
        coordenadasFinal.push(...coordsTemp);
      }

      if (geometry.type == "Point"){
        coordsTemp = [geometry.coordinates[0], geometry.coordinates[1]];
        coordenadasFinal.push(coordsTemp);
      }
    }

    const bounds = new mapboxgl.LngLatBounds(coordenadasFinal[0], coordenadasFinal[0]);
    // Extiende el bounds para que tenga todas las coordenadas.
    for (const coord of coordenadasFinal) {
      bounds.extend(coord);
    }
    
    const bb = [
      [bounds.getSouthWest().lng, bounds.getSouthWest().lat],
      [bounds.getNorthEast().lng, bounds.getNorthEast().lat],
    ];
    // Ajustar el mapa para que encaje en los bounds
      this.miniMap.fitBounds(bb, {
        padding: {top: 10, bottom:10, left: 10, right: 10},
        duration: 0
    });
    const currentZoom = this.miniMap.getZoom();
    this.miniMap.setZoom(currentZoom - 1);
  }

  ResizeMap(){
    this.miniMap.resize();
  }
  
}
